import BusinessIntelligenceService from '../services/business-intelligence-service';

export const businessIntelligence = {
  namespaced: true,
  state: {
    searchResult: null,
    pageNumber: 0,
    businessIntelligencePageNumber: 0,
    lastSearchConfig: null,
    applicationSearchResult: null,
    trustmarkBusiness: null,
    trustmarkBusinessTrades: null,
    businessIntelligenceActivityLogs: null,
  },
  actions: {
    searchBusinessIntelligence({ commit }, data) {
      data.type = 'standard';
      commit('setLastSearchConfig', data);
      return BusinessIntelligenceService.search(data).then(
        (result) => {
          commit('setBusinessIntelligenceSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },
    searchBusinessAdvanced({ commit }, data) {
      data.type = 'advanced';
      commit('setLastSearchConfig', data);
      return BusinessIntelligenceService.advancedSearch(data).then(
        (result) => {
          commit('setBusinessIntelligenceSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },
    getTrustmarkBusiness({ commit }, trustmarkBusinessId) {
      commit('setIsBusy', true, { root: true });
      return BusinessIntelligenceService.getById(trustmarkBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setTrustmarkBusiness', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },
    getTrustmarkBusinessTrades({ commit }, trustmarkBusinessId) {
      return BusinessIntelligenceService.getTrades(trustmarkBusinessId).then(
        (result) => {
          commit('setTrustmarkBusinessTrades', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },
    async getBusinessIntelligenceActivityLogs({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      await new Promise((resolve) => setTimeout(resolve, 2000));
      return BusinessIntelligenceService.getBusinessIntelligenceActivityLogs(payload).then(
        (result) => {
          console.log('result', result);
          commit('setIsBusy', false, { root: true });
          commit('setBusinessIntelligenceActivityLogs', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },
  },
  mutations: {
    setBusinessIntelligenceSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
    setLastSearchConfig(state, searchconfig) {
      state.lastSearchConfig = searchconfig;
    },
    setSearchPageNumber(state, newPageNumber) {
      state.pageNumber = newPageNumber;
    },
    setBusinessIntelligencePageNumber(state, newPageNumber) {
      state.businessIntelligencePageNumber = newPageNumber;
    },
    setTrustmarkBusiness(state, trustmarkBusiness) {
      state.trustmarkBusiness = trustmarkBusiness;
    },
    setTrustmarkBusinessTrades(state, trades) {
      state.trustmarkBusinessTrades = trades;
    },
    setBusinessIntelligenceActivityLogs(state, activityLogs) {
      state.businessIntelligenceActivityLogs = activityLogs;
    },
  },
};
